import { Observable } from 'rxjs';
import { Action } from 'redux';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { CANCEL_SUBSCRIPTION } from '../actions';
import * as subscriptions from '@webapp/sdk/subscriptions';
import {
  CancelSubscription,
  CancelSubscriptionSuccess,
  CancelSubscriptionError,
} from '../action-creators';

export const cancelSubscriptionEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, CancelSubscription>(CANCEL_SUBSCRIPTION),
    mergeMap(async (action) => {
      try {
        const subscription = await subscriptions.cancel(
          action.clientId,
          action.plan
        );

        if (action.onSuccess) {
          action.onSuccess();
        }

        return new CancelSubscriptionSuccess(subscription);
      } catch (err) {
        let message = err.message;

        if (err.error?.message) {
          message = err.error.message;
        }

        return new CancelSubscriptionError(message);
      }
    })
  );
